'use client'

import { EventsExplore } from '@/components/events/EventsExplore'
import { Topic } from '@/payload-types'
import { EventsProvider } from '@/providers/EventsProvider'

import type { DisplayEvent } from '@/utilities/events/displayEvent'

export const EventsExploreBlockClient: React.FC<{
  featured?: DisplayEvent | null
  eventsResult: { docs: DisplayEvent[]; totalDocs: number }
  eventTopicsByView: { all: Topic[]; official: Topic[]; unofficial: Topic[] }
  eventTopicCountsByView: {
    all: { [key: number]: number }
    official: { [key: number]: number }
    unofficial: { [key: number]: number }
  }
}> = ({ featured, eventsResult, eventTopicsByView, eventTopicCountsByView }) => {
  return (
    <EventsProvider
      featured={featured}
      initialEvents={eventsResult.docs}
      initialTotalDocs={eventsResult.totalDocs}
      eventTopicsByView={eventTopicsByView}
      eventTopicCountsByView={eventTopicCountsByView}
    >
      <EventsExplore />
    </EventsProvider>
  )
}
